<template>
  <a
    class="ExternalFormCTA"
    v-if="shouldShowExternalFormCTA()"
    :margin="margin"
    :href="NETHERLANDS.externalFormCTALink"
  >
    {{ $t('homepage.google_cta') }}
  </a>
</template>
<script>
import {
  shouldShowExternalFormCTA,
  NETHERLANDS,
} from '../../../shared/entityHelpers';

export default {
  props: ['margin'],
  data() {
    return {
      NETHERLANDS,
    };
  },
  methods: {
    shouldShowExternalFormCTA,
  },
};
</script>
<style scoped>
.ExternalFormCTA {
  display: block;
  background: var(--qwellow);
  color: var(--qwray);
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #ffdf22;
  font: normal normal bold 14px/18px Lato;
  height: max-content;
  width: max-content;
  border-radius: 37px;
  letter-spacing: 0.22px;
  padding: 1em 2em;
}
.ExternalFormCTA[margin] {
  margin-bottom: 4em;
}
@media (min-width: 768px) {
  .ExternalFormCTA {
    font: normal normal bold 24px/28px Lato;
    letter-spacing: 0.48px;
    border-radius: 40px;
    padding: 1em 1.8em;
    width: max-content;
  }
  .ExternalFormCTA[margin] {
    margin-bottom: unset;
  }
}
</style>
